export const getPrintPath = (
    api:string,
    settings: URLSearchParams
) => {
    settings.delete('page')
    settings.delete('pageSize')
    return `${api}?${settings}&pageSize=all`
}